import log from 'salvo-lite/log'

class PageSantander {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        /**
         * Only need to load content expansion once to set the events.
         */
        window.contentExpansionLoaded = false
    }
}

export default PageSantander



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/PageSantander.js